export default __webpack_public_path__ + "static/media/title_zh_tw_sp.c8a4c388.png";